var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{attrs:{"href":"#","title":"Transmettre ce point"},on:{"click":function($event){return _vm.sendItem()}}},[_c('i',{staticClass:"fas fa-fw fa-share-square text-secondary"})])
}
var staticRenderFns = []

export { render, staticRenderFns }